/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSavingsV2StatusRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetSavingsV2StatusResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getSavingsV2Status = (request: GetSavingsV2StatusRequest, options?: CashRequestOptions) => post<GetSavingsV2StatusRequest, GetSavingsV2StatusResponse>("/2.0/cash/get-savings-v2-status", request, {...options, rejectOnError: true })